import React, {h, Component} from 'preact';
import './VideoPlayerModal.scss';

export default class VideoPlayerModal extends Component {
    render() {
        const {
            realtorName,
            photo,
            width,
            height,
            url,
            allow,
            isYoutubeVideo,
            lastUpdated,
            onModalClose,
            clientType,
            status,
            wonQuote
        } = this.props;

        return (
            <div className="modal nu-modal fade video-player-modal" role="dialog">
                <div className="nu-modal-content">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="agent">
                                    <div className="green-dot"></div>
                                    <img
                                        className="agent-photo"
                                        ref={el => (this.photo = el)}
                                        src={photo}
                                        onError={() => replaceImageOnError(this.photo, 'img/profile-icon-lg.jpg')}
                                    />
                                    <div className="description">
                                        <div className="realtor-name">
                                            You got a new video message from <b>{realtorName}</b>
                                        </div>
                                        <div className="video-received-at">{lastUpdated}</div>
                                    </div>
                                </div>
                                <iframe
                                    className="youtube-player"
                                    type="text/html"
                                    src={url}
                                    frameborder={0}
                                    scrolling="no"
                                    allowspeakers="allowspeakers"
                                    allowautoplay="allowautoplay"
                                    allowfullscreen="allowfullscreen"
                                    allow="speakers *; autoplay *; fullscreen *"
                                />
                                <div className="action-buttons clearfix">
                                    <div
                                        className="btn button button-custom rounded outline gray"
                                        onClick={onModalClose}>
                                        Close
                                    </div>
                                    <hr className="visible-xs" />
                                    {status == 2 && !wonQuote && (
                                        <div
                                            className="btn button button-custom rounded outline orange"
                                            onClick={e => {
                                                trackEvent(
                                                    'Proposal',
                                                    'PreInterviewVideo',
                                                    'clientCallAgentPreInterviewVideoPopUp',
                                                    {
                                                        clientType
                                                    }
                                                );
                                                onModalClose(e, 'call-button');
                                            }}>
                                            <i className="icon icon-contact-phone-outline" /> Call Agent
                                        </div>
                                    )}
                                    {status == 2 && !wonQuote && (
                                        <div
                                            className="btn button button-custom rounded orange"
                                            onClick={e => {
                                                trackEvent(
                                                    'Proposal',
                                                    'PreInterviewVideo',
                                                    'clientSelectAgentPreInterviewVideoPopUp',
                                                    {
                                                        clientType
                                                    }
                                                );
                                                onModalClose(e, 'select-agent-action');
                                            }}>
                                            <i className="icon icon-nav-check" /> Select Agent
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
